<template>
  <el-card class="section-card">
    <img :src="imgSrc" :alt="imgAlt" class="card-image" />
    <div class="textos">
      <h3>{{ title }}</h3>
      <p>{{ description }}</p>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "SectionCard",
  props: {
    title: String,
    description: String,
    imgSrc: String,
    imgAlt: String
  }
};
</script>
<style>
.section-card .el-card__body {
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: space-between;
}
</style>

<style scoped>
.section-card {
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 0;
  align-items: flex-start;
  border: 0;
  margin-bottom: 20px;
}

.textos {
  flex: 1;
  padding: 20px;
  width: 100%;
}

.card-image {
  width: 100px;
  height: 140px;
  object-fit: cover;
}
</style>
